<template>
  <v-dialog v-model="visible" max-width="1400">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col v-for="(item, indice) in listado" :key="indice" cols="12" md="4" lg="3" class="pa-0">
            <ListadoItem :nombreCampo="item.nombre" :valorCampo="item.valor" />
          </v-col>

          <v-col cols="12">
            <v-btn class="mx-1" title="Recargar" small @click="listar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12">
            <ListadoProgramas ref="listadoRef" :items="items" :cargando="false" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ListadoProgramas from './ListadoProgramas.vue';
import programaUniversidadMixin from '../mixins/programa-universidad.mixin';
import programaService from '../services/programa.service';

export default {
  name: 'ModalMostrarProgramas',
  mixins: [programaUniversidadMixin],
  components: { ListadoProgramas },
  data() {
    return {
      nombreItem: 'Programas',
    };
  },
  methods: {
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
      this.listar();
    },
    listar() {
      this.items = [];

      const params = {
        programasIds: this.form.programas.map((item) => item.id),
      };

      this.obtenerDatosConNotificacion(
        programaService.findProgramasConCantidadInscripcionesUniversidad,
        'items',
        'Programas con Cantidad de Inscripciones Universidad',
        params,
      );
    },
  },
};
</script>